import React from 'react'
import styles from './ProfileCompletionForm.module.css'
import { AccountAlert, CloseIcon } from '../../Assets'
import { Box, Grid, Typography } from '@mui/material'
import {
    ButtonCmp,
    DropDownCmp,
    WhiteButtonCmp,
    InputCmp,
} from '../../Components'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useState } from 'react'
import {
    GetLicensedServicesAction,
    GetOtherServicesAction,
    CreateServiceAction,
} from '../../Store/Actions/GetActions'
import { useDispatch, useSelector } from 'react-redux'
import {
    EmptyProfileWizardState,
    ProfileWizardAction,
} from '../../Store/Actions/ProfileAction'
import useAlert from '../../Hooks/useAlert/useAlert'

const ServicesForm = ({ setWhichForm, setBarPercent, setServicesComplete }) => {
    const navigate = useNavigate()
    const [servicesArr, setServicesArr] = useState([])
    const [otherServicesArr, setOtherServicesArr] = useState([])
    const [showLicensedServiceInput, setShowLicensedServiceInput] =
        useState(false)
    const [showOtherServiceInput, setShowOtherServiceInput] = useState(false)

    const [constructionType, setConstructionType] = useState('')

    const { setAlert } = useAlert()
    const dispatch = useDispatch()
    const { licensedServicesdata } = useSelector(
        (state) => state.LicensedServicesReducer
    )
    const { otherServicesdata } = useSelector(
        (state) => state.OtherServicesReducer
    )
    const { createServiceLoading } = useSelector(
        (state) => state.CreateServiceReducer
    )

    const { control, handleSubmit, watch, setValue, getValues } = useForm({
        mode: 'onChange',
        defaultValues: {
            licensedService: '',
            otherService: '',
            newLicensedService: '',
            newOtherService: '',
        },
    })

    const licensedServiceState = watch('licensedService')
    const otherServiceState = watch('otherService')
    const newLicensedServiceState = watch('newLicensedService')
    const newOtherServiceState = watch('newOtherService')
    const { profileWizarddata } = useSelector(
        (state) => state.ProfielWizardReducer
    )
    useEffect(() => {
        if (licensedServiceState) {
            const alreadyExist = servicesArr.find(
                (i) => i.slug === licensedServiceState.slug
            )
            if (alreadyExist) {
                setAlert('This service already exist', 'error')
                setValue('licensedService', '')
                return
            }
            setServicesArr([...servicesArr, licensedServiceState])
            setValue('licensedService', '')
        }
    }, [licensedServiceState])

    useEffect(() => {
        if (otherServiceState) {
            otherServicesArr.push(otherServiceState)
            setOtherServicesArr([...new Set(otherServicesArr)])
            setValue('otherService', '')
        }
    }, [otherServiceState])

    useEffect(() => {
        dispatch(GetLicensedServicesAction())
        dispatch(GetOtherServicesAction())
    }, [])

    const onSubmit = (obj) => {
        const objSent = {
            servicesArr,
            otherServicesArr,
            constructionType,
        }
        dispatch(ProfileWizardAction(objSent, 'services', setAlert))

        // setWhichForm("socialMedia");
        // setBarPercent("75%");
        // setServicesComplete(true);
    }

    const removeService = (ind, whichService) => {
        if (whichService === 'licensedService') {
            servicesArr.splice(ind, 1)
            setServicesArr([...servicesArr])
        } else {
            otherServicesArr.splice(ind, 1)
            setOtherServicesArr([...otherServicesArr])
        }
    }

    const handleAddNewLicensedService = async () => {
        const newServiceValue = getValues('newLicensedService')
        if (newServiceValue && newServiceValue.trim()) {
            const serviceData = {
                title: newServiceValue.trim(),
                isLicensed: true,
                // description: newServiceValue.trim()
            }

            const createdService = await dispatch(
                CreateServiceAction(serviceData, setAlert)
            )

            if (createdService) {
                const newService = {
                    id: createdService.id,
                    label: createdService.title,
                    value:
                        createdService.slug ||
                        createdService.title.toLowerCase().replace(/\s+/g, '_'),
                    slug:
                        createdService.slug ||
                        createdService.title.toLowerCase().replace(/\s+/g, '_'),
                }
                setServicesArr([...servicesArr, newService])
                setValue('newLicensedService', '')
                setShowLicensedServiceInput(false)
            }
        }
    }

    const handleAddNewOtherService = async () => {
        const newServiceValue = getValues('newOtherService')
        if (newServiceValue && newServiceValue.trim()) {
            const serviceData = {
                title: newServiceValue.trim(),
                isLicensed: false,
                // description: newServiceValue.trim()
            }

            const createdService = await dispatch(
                CreateServiceAction(serviceData, setAlert)
            )

            if (createdService) {
                const newService = {
                    id: createdService.id,
                    label: createdService.title,
                    value:
                        createdService.slug ||
                        createdService.title.toLowerCase().replace(/\s+/g, '_'),
                    slug:
                        createdService.slug ||
                        createdService.title.toLowerCase().replace(/\s+/g, '_'),
                }
                setOtherServicesArr([...otherServicesArr, newService])
                setValue('newOtherService', '')
                setShowOtherServiceInput(false)
            }
        }
    }

    const handleCancelLicensedService = () => {
        setValue('newLicensedService', '')
        setShowLicensedServiceInput(false)
    }

    const handleCancelOtherService = () => {
        setValue('newOtherService', '')
        setShowOtherServiceInput(false)
    }

    useEffect(() => {
        if (profileWizarddata) {
            setWhichForm('insuranceInfo')
            setBarPercent(`${(100 / 5) * 3}%`)
            setServicesComplete(true)
            dispatch(EmptyProfileWizardState())
        }
    }, [profileWizarddata])

    return (
        <section className={styles.profile_services}>
            <div className={styles.profile_information_heading}>
                <Typography noWrap variant="h5" fontWeight={'bold'}>
                    Services Provided
                </Typography>
                {/* <IconCmp>
                                    <BiEdit />
                                </IconCmp> */}
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={1}>
                    <Grid sm={4}>
                        <section className={styles.servicesLicensed}>
                            <Typography
                                noWrap
                                mt={'40px'}
                                variant="h6"
                                fontWeight={'600'}
                            >
                                Construction Type
                            </Typography>
                            <Box sx={{ my: '20px', maxWidth: 300 }}>
                                <DropDownCmp
                                    name="constructionType"
                                    control={{
                                        ...control,
                                        register: (...args) => {
                                            const original = control.register(
                                                ...args
                                            )
                                            return {
                                                ...original,
                                                onChange: (e) => {
                                                    setConstructionType(
                                                        e.target.value
                                                    )
                                                    if (original.onChange)
                                                        original.onChange(e)
                                                },
                                            }
                                        },
                                    }}
                                    label="Construction Type"
                                    options={[
                                        'Residential',
                                        'Commercial',
                                        // 'Both (Residential + Commercial)',
                                        'Both',
                                    ]}
                                    placeholder="Select Construction Type"
                                    disableClearable
                                    freeSolo={false}
                                    value={constructionType}
                                />
                            </Box>
                        </section>
                    </Grid>
                    <Grid sm={8}>
                        <section className={styles.servicesLicensed}>
                            <Typography
                                noWrap
                                mt={'40px'}
                                variant="h6"
                                fontWeight={'600'}
                            >
                                Licensed Service
                            </Typography>
                            <Box sx={{ my: '20px' }}>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <DropDownCmp
                                            name="licensedService" //imporant
                                            control={control} //imporant
                                            label="Select Services"
                                            options={
                                                licensedServicesdata && [
                                                    ...licensedServicesdata,
                                                    // ...otherServicesdata,
                                                ]
                                            }
                                            disableClearable
                                            freeSolo={false}
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                            {/* ///tags// */}
                            <div>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: '20px',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    {servicesArr.length > 0 &&
                                        servicesArr.map((service, ind) => {
                                            return (
                                                <div
                                                    key={ind}
                                                    className={
                                                        styles.scrollTabsBar
                                                    }
                                                >
                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems:
                                                                'center',
                                                            gap: '5px',
                                                        }}
                                                    >
                                                        <img
                                                            alt="serviceLogo"
                                                            src={AccountAlert}
                                                            style={{
                                                                marginBottom:
                                                                    '2px',
                                                            }}
                                                        />
                                                        {service.label}
                                                    </Box>
                                                    <Box>
                                                        <CloseIcon
                                                            sx={{
                                                                cursor: 'pointer',
                                                                fontSize:
                                                                    '18px',
                                                                mt: '5px',
                                                            }}
                                                            onClick={() =>
                                                                removeService(
                                                                    ind,
                                                                    'licensedService'
                                                                )
                                                            }
                                                        />
                                                    </Box>
                                                </div>
                                            )
                                        })}
                                </Box>
                            </div>
                        </section>
                    </Grid>
                </Grid>

                <section className={styles.servicesLicensed}>
                    <Typography noWrap variant="h6" fontWeight={'bold'}>
                        Other Service
                    </Typography>
                    <Box sx={{ my: '50px' }}>
                        <Grid container spacing={2} alignItems="center">
                            <Grid item lg={4}>
                                <DropDownCmp
                                    name="otherService" //imporant
                                    control={control} //imporant
                                    label="Select Services"
                                    options={
                                        otherServicesdata && otherServicesdata
                                    }
                                    disableClearable
                                    freeSolo={false}
                                />
                            </Grid>
                            {showOtherServiceInput ? (
                                <Grid item xs={8}>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            gap: 2,
                                            alignItems: 'center',
                                        }}
                                    >
                                        <InputCmp
                                            name="newOtherService"
                                            control={control}
                                            label="Enter new service name"
                                            style={{ flex: 1 }}
                                        />
                                        <ButtonCmp
                                            title={
                                                createServiceLoading
                                                    ? 'Adding...'
                                                    : 'Add'
                                            }
                                            onClick={handleAddNewOtherService}
                                            type="button"
                                            disabled={createServiceLoading}
                                        />
                                        <WhiteButtonCmp
                                            title="Cancel"
                                            onClick={handleCancelOtherService}
                                            type="button"
                                            disabled={createServiceLoading}
                                        />
                                    </Box>
                                </Grid>
                            ) : (
                                <Grid item lg={2}>
                                    <ButtonCmp
                                        title="Add New Service"
                                        onClick={() =>
                                            setShowOtherServiceInput(true)
                                        }
                                        type="button"
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </Box>
                    {/* ///tags// */}
                    <Box sx={{ display: 'flex', gap: '20px' }}>
                        {otherServicesArr.map((service, ind) => {
                            return (
                                <section
                                    key={service.id}
                                    className={styles.scrollTabsBar}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '5px',
                                        }}
                                    >
                                        <img src={AccountAlert} alt="" />
                                        {service.label}
                                    </Box>
                                    <Box>
                                        <CloseIcon
                                            sx={{
                                                cursor: 'pointer',
                                                fontSize: '18px',
                                            }}
                                            onClick={() =>
                                                removeService(
                                                    ind,
                                                    'otherService'
                                                )
                                            }
                                        />
                                    </Box>
                                </section>
                            )
                        })}
                    </Box>
                </section>

                <section className={styles.formBtns}>
                    {/* <WhiteButtonCmp
                        title="Cancel"
                        onClick={() => {
                            navigate('/profile')
                        }}
                    /> */}
                    <ButtonCmp
                        title="Skip Step"
                        onClick={() => {
                            setWhichForm('insuranceInfo')
                        }}
                    />
                    <ButtonCmp title="Save and Continue" type="submit" />
                </section>
            </form>
        </section>
    )
}

export default ServicesForm
